/* tslint:disable */
/* eslint-disable */
/**
 * lis-prod-rest-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2024-01-08T10:35:12Z
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ReportLocations } from './report-locations';

/**
 * 
 * @export
 * @interface Report
 */
export interface Report {
    /**
     * 
     * @type {number}
     * @memberof Report
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    createDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    completionDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    kfwReferenceId?: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    kfwReportId?: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    reporterPostalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    reportType?: ReportReportTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    state?: ReportStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Report
     */
    showNotification?: boolean;
    /**
     * 
     * @type {Array<ReportLocations>}
     * @memberof Report
     */
    locations?: Array<ReportLocations>;
}

/**
    * @export
    * @enum {string}
    */
export enum ReportReportTypeEnum {
    Commune = 'COMMUNE',
    Company = 'COMPANY',
    Ptj = 'PTJ'
}
/**
    * @export
    * @enum {string}
    */
export enum ReportStateEnum {
    Complete = 'COMPLETE',
    Incomplete = 'INCOMPLETE',
    Cancelled = 'CANCELLED'
}



